/**
 * WCAG 2.2.2 Pause, Stop, Hide — visible pause/play control for Flickity
 * carousels that have data-autoplay > 0. Runs after slideshow.min.js
 * has initialised Flickity, so Flickity.data(el) returns the live instance.
 *
 * The button is hidden entirely when the user has
 * prefers-reduced-motion: reduce, because slideshow.min.js already
 * skips autoplay in that mode (so there is nothing to pause).
 */
(function () {
  function getStrings() {
    var strings = (window.theme && window.theme.strings) || {};
    return {
      pause: strings.pauseSlideshow || 'Pause slideshow',
      play: strings.playSlideshow || 'Play slideshow',
    };
  }

  function injectStyles() {
    if (document.getElementById('slideshow-pause-styles')) return;
    var style = document.createElement('style');
    style.id = 'slideshow-pause-styles';
    style.textContent = [
      '.carousel-pause{position:absolute;bottom:12px;right:12px;width:36px;height:36px;min-width:36px;min-height:36px;padding:6px;background:rgba(0,0,0,.55);border:0;border-radius:50%;color:#fff;cursor:pointer;display:inline-flex;align-items:center;justify-content:center;z-index:6}',
      '.carousel-pause:focus-visible{outline:2px solid #fff;outline-offset:2px}',
      '.carousel-pause svg{width:14px;height:14px;fill:currentColor;pointer-events:none}',
      '.carousel-pause .icon-play{display:none}',
      '.carousel.is-paused .carousel-pause .icon-pause{display:none}',
      '.carousel.is-paused .carousel-pause .icon-play{display:block}',
    ].join('\n');
    document.head.appendChild(style);
  }

  function makeButton(labels) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'carousel-pause';
    btn.setAttribute('aria-pressed', 'false');
    btn.setAttribute('aria-label', labels.pause);
    btn.innerHTML =
      '<svg class="icon-pause" aria-hidden="true" focusable="false" viewBox="0 0 14 14">' +
      '<rect x="3" y="2" width="3" height="10" rx="1"/><rect x="8" y="2" width="3" height="10" rx="1"/>' +
      '</svg>' +
      '<svg class="icon-play" aria-hidden="true" focusable="false" viewBox="0 0 14 14">' +
      '<path d="M3.5 2.5v9l8-4.5z"/></svg>';
    return btn;
  }

  function wire(carousel, labels) {
    if (carousel.dataset.pauseWired === '1') return;
    var raw = carousel.dataset.autoplay;
    if (!raw || raw === 'false' || raw === '0') return;
    var ms = parseInt(raw, 10);
    if (!ms || ms <= 0) return;
    if (typeof Flickity === 'undefined') return;
    var flkty = Flickity.data(carousel);
    if (!flkty) return; // not initialised yet; caller retries
    // Nothing to pause if there is only a single slide.
    if (!flkty.cells || flkty.cells.length < 2) {
      carousel.dataset.pauseWired = '1';
      return;
    }
    // If the user has prefers-reduced-motion:reduce, slideshow.min.js
    // already disabled autoplay — flkty.player.state is 'stopped' and
    // there is nothing meaningful to pause.
    if (
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    )
      return;
    if (getComputedStyle(carousel).position === 'static') {
      carousel.style.position = 'relative';
    }
    var btn = makeButton(labels);
    carousel.appendChild(btn);
    carousel.dataset.pauseWired = '1';
    btn.addEventListener('click', function () {
      var pausedNow = carousel.classList.toggle('is-paused');
      if (pausedNow) {
        flkty.pausePlayer();
        btn.setAttribute('aria-pressed', 'true');
        btn.setAttribute('aria-label', labels.play);
      } else {
        flkty.unpausePlayer();
        btn.setAttribute('aria-pressed', 'false');
        btn.setAttribute('aria-label', labels.pause);
      }
    });
  }

  function init() {
    injectStyles();
    var labels = getStrings();
    var carousels = document.querySelectorAll('.carousel[data-autoplay]');
    if (!carousels.length) return;
    carousels.forEach(function (c) {
      wire(c, labels);
    });
    // Flickity init can run after our first pass (defer + DOMContentLoaded
    // race). Retry a few times before giving up.
    var tries = 0;
    var retryId = window.setInterval(function () {
      tries += 1;
      carousels.forEach(function (c) {
        wire(c, labels);
      });
      if (tries >= 10) window.clearInterval(retryId);
    }, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
